import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card } from '~/components/Card';
import { ServicesContext } from '~/services';
import { useServiceSubscribe } from '~/util';
import { MfaSelect, MfaVerify } from '.';

export function Mfa() {
    const servicesContext = React.useContext(ServicesContext);
    const history = useHistory();
    const [submitted, setSubmitted] = React.useState(false);

    function redirectToLogin() {
        history.push('/');
    }

    useServiceSubscribe(servicesContext.user.events.userLoggedOut, redirectToLogin);

    return (
        <Card title="For Your Protection">
            {!submitted ? (
                <MfaSelect submitAction={setSubmitted} />
            ) : (
                <MfaVerify submitAction={setSubmitted} />
            )}
        </Card>
    );
}
